import { render, staticRenderFns } from "./course-list.vue?vue&type=template&id=dffcba6e&scoped=true"
import script from "./course-list.vue?vue&type=script&lang=js"
export * from "./course-list.vue?vue&type=script&lang=js"
import style0 from "./course-list.vue?vue&type=style&index=0&id=dffcba6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffcba6e",
  null
  
)

export default component.exports